export default "__VITE_ASSET___PpX0tpI__"